import React, { useState, useEffect } from 'react'
import Grid from '@material-ui/core/Grid'
import CircularProgress from '@material-ui/core/CircularProgress'
import { makeStyles } from '@material-ui/core/styles'
import Forms from 'components/forms'
import { useMergedState } from 'hooks'
import API from 'api'
import { dataDerivar } from './mock'

const style = makeStyles(theme => ({
  cancelButton: {
    marginRight: theme.spacing(2),
  },
  form: {
    paddingTop: theme.spacing(1.5),
  },
}))

export default function DerivateForm({ onCloseModal, experienceId, setMessage, refreshPage }) {
  const classes = style()
  const [form, setForm] = useState({ fieldsById: [], sections: [], data: {} })
  const [{ loading, error }, setState] = useMergedState({
    loading: true,
    error: null,
  })

  const haddleOnCLick = async data => {
    try {
      await new API({
        endpoint: `post`,
        url: `validator/derivar/region/experiencia`,
        data: { ...data, id: experienceId },
      }).send()
      setMessage(`Experiencia derivada`, `success`)
      refreshPage()
    } catch (e) {
      setMessage(`La experiencia no pudo ser derivada`)
      refreshPage()
    }
  }

  const handleForm = async (
    { region_id: { value: id = null, items: ItemsRegiones = [] } },
    data,
    name,
  ) => {
    if (name === `region_id`) {
      setState({ error, loading: true })
      const usuarios = await new API({
        endpoint: `get`,
        url: `validator/users/region/${id}`,
      }).send()
      const { fieldsById = [], sections = [] } = await dataDerivar({
        regiones: ItemsRegiones,
        regionID: id,
        usuarios: usuarios.data,
      })
      setForm({ fieldsById, sections: sections.fieldsIds, data })
      setState({ error, loading: false })
    }
  }

  const getData = async () => {
    const regiones = await new API({
      endpoint: `getItemsRegiones`,
    }).send()
    const { fieldsById = [], sections = [] } = await dataDerivar({ regiones: regiones.data })
    setForm({ fieldsById, sections: sections.fieldsIds })
    setState({ error, loading: false })
  }

  useEffect(() => {
    getData()
    // eslint-disable-next-line
  }, [])

  const { fieldsById = [], sections = [], data = {} } = form

  return (
    <Grid container className={classes.form}>
      {loading ? (
        <Grid
          className={classes.loading}
          item
          container
          xs={12}
          justify="center"
          alignItems="center"
        >
          <CircularProgress color="secondary" />
        </Grid>
      ) : (
        <Forms
          dataForm={data}
          handle={handleForm}
          classes={classes}
          fieldsById={fieldsById}
          sections={sections}
          submitForm={haddleOnCLick}
          loading={loading}
          onCancel={onCloseModal}
          cancelText="Cancelar"
          acceptText="Enviar respuesta"
          error={error}
          buttonsSize="medium"
          buttonsFullWidth={false}
        />
      )}
    </Grid>
  )
}
